import { GetOneExpeditionBoResponseDto } from "@/types/api/api-types";
import { useTranslation } from "react-i18next";
import { Element } from "@/components/validatedShipments/element";

type PaletteDetailProps = {
  expedition: GetOneExpeditionBoResponseDto;
};

export const PaletteDetail = ({ expedition }: PaletteDetailProps) => {
  const { t } = useTranslation("boQuotations");
  const paletteProducts = expedition.customQuotation?.paletteDetail?.paletteProducts;
  const palettePackages = expedition.customQuotation?.paletteDetail?.palettePackages;

  return (
    <div className="flex w-full flex-col gap-6">
      <div className="flex w-full flex-col gap-2">
        {paletteProducts?.map((paletteProduct, index) => (
          <Element
            key={index}
            title={t("paletteDetail.productTitle", { number: index + 1 })}
            value={t("paletteDetail.bottles", {
              quantity: paletteProduct.bottleQuantity,
              volume: paletteProduct.volume,
            })}
          />
        ))}
        <div className="grid w-full grid-cols-2 justify-between">
          <div className="flex w-fit flex-row gap-4">
            <input
              type="checkbox"
              className="peer w-[16px]"
              checked={expedition.expeditionOptions?.insurance}
              readOnly
            />
            <label className="text-sm font-medium text-gray-700">
              {t("paletteDetail.insuranceLabel")}
            </label>
          </div>
          <div className="flex w-fit flex-row gap-4">
            <input
              type="checkbox"
              className="peer w-[16px]"
              checked={expedition.expeditionOptions?.express}
              readOnly
            />
            <label className="text-sm font-medium text-gray-700">
              {t("paletteDetail.expressLabel")}
            </label>
          </div>
        </div>
        {palettePackages?.map((palettePackage, index) => (
          <>
            <Element
              key={index + "dimensions"}
              title={t("paletteDetail.dimensionsTitle", { number: index + 1 })}
              value={t("paletteDetail.dimensionsValue", {
                height: palettePackage.height,
                length: palettePackage.length,
                width: palettePackage.width,
              })}
            />
            <Element
              key={index + "weight"}
              title={t("paletteDetail.weightTitle", { number: index + 1 })}
              value={`${palettePackage.weight} kg`}
            />
            <Element
              key={index + "value"}
              title={t("paletteDetail.valueTitle", { number: index + 1 })}
              value={`${palettePackage.value} €`}
            />
          </>
        ))}
      </div>
    </div>
  );
};
